export default __webpack_public_path__ + "static/media/iconicons.34005b05.webp";